import classNames from "classnames";
import { graphql } from "gatsby";
import React from "react";
import Icon from "../atoms/icon";

const NotificationEcommerce = ({ data }) => {
  return (
    <>
      <div className="product-card__notification">
        {data.icons.alternativeIcon || data.icons.icon ? (
          <div className="headerBanner-image">
            <Icon
              className={`icon-${data.icons.icon}`}
              name={data.icons.alternativeIcon ? "custom" : data.icons.icon}
              url={
                data.icons.width || data.icons.height || data.icons.alternativeIcon?.node?.publicURL
                  ? data.icons.alternativeIcon?.node?.publicURL
                  : data.icons.alternativeIcon?.node?.resize?.src
              }
              width={data.icons.width}
              height={data.icons.height}
              alt={data.icons.alternativeIcon ? data.icons.alternativeIcon.value?.description : ""}
            />
          </div>
        ) : null}
        <div
          className={classNames(
            "product-card__message",
            data.color?.[0] && `product-card__message--${data.color[0]}`
          )}
          dangerouslySetInnerHTML={{
            __html: data.text,
          }}
        ></div>
      </div>
    </>
  );
};

export default NotificationEcommerce;

export const fragment = graphql`
  fragment NotificationEcommerceFragment on LiferayNotification {
    text
    color
    icons {
      alternativeIcon {
        node {
          publicURL
          resize {
            src
          }
        }
        value {
          description
        }
      }
      width
      height
    }
  }
`;
